module.exports = __webpack_public_path__ + "img/logo-sv.af3a69fe.svg";